import {isBefore, isoDateToday, PopupDatePicker} from "@amzn/stencil-react-components/date-picker";
import {convertIsoStringToDateTime} from "src/util/commonUtil";
import {
    EventModelState,
    updateValidFrom,
    updateValidTill
} from "src/state/slice/EventModelSlice";
import {InputWrapper} from "@amzn/stencil-react-components/form";
import React from "react";
import {useAppDispatch, useAppSelector} from "src/state/hooks";
import {StringUtils, TimestampInputValidity} from "src/constant/constants";
import "src/components/authoringComponents/styles/TimestampInput.scss";
import {IconWithTooltip} from "src/components/helperComponents/IconWithTooltip";
import {Row, Spacer} from "@amzn/stencil-react-components/layout";

interface ITimeStampInput {
    attributeName: string;
    tooltipText: string;
}

export const TimestampInput = ({attributeName, tooltipText}: ITimeStampInput) => {

    const dispatch = useAppDispatch();
    const eventModelState: EventModelState = useAppSelector(({eventModel}) => eventModel);
    return <Row>
        <InputWrapper
            labelText={StringUtils.EMPTY}
            id={`${attributeName}-input`}
            footer={"Please select a date after " + new Date()}
            error={false}>
            {
                inputProps => (
                    <PopupDatePicker
                        {...inputProps}
                        defaultValue={attributeName === TimestampInputValidity.VALID_FROM ?
                            !!eventModelState?.validFrom && convertIsoStringToDateTime(eventModelState?.validFrom) :
                            !!eventModelState?.validTill && convertIsoStringToDateTime(eventModelState?.validTill)
                        }
                        popoverProps={{
                            shouldCloseOnFocusLeave: true
                        }}
                        showTime={true}
                        onChange={(date) => {
                            attributeName === TimestampInputValidity.VALID_FROM ?
                                dispatch(updateValidFrom(String(new Date(new Date(date).toISOString()).getTime()))) :
                                dispatch(updateValidTill(String(new Date(new Date(date).toISOString()).getTime())))
                        }}
                        isDateDisabled={(date) => !!date && isBefore(isoDateToday())(date)}
                        inputProps={{
                            width: '100%',
                            onKeyDown: e => e.preventDefault()
                        }}
                    />
                )}
        </InputWrapper>
        <Spacer width={"4px"}/>
        <IconWithTooltip
            tooltipText={tooltipText}
            color={"primary70"}
        />
    </Row>
}
